<template>
  <div class="col-md-4 ml-auto mr-auto">
    <form @submit.prevent="login">
      <card class="card-login card-plain">
        <div slot="header">
          <div class="logo-container">
            <img src="img/qc_logo.png" alt />
          </div>
        </div>

        <div>
          <div class="text-center login-title">
            <h3>
              <router-link class="link footer-link" to="/register">經銷商管理後台</router-link>
            </h3>
          </div>
          <p style="color:#BA0000;" v-if="signinError">
            <strong>請確認經銷商帳號、用戶Email及密碼是否正確</strong>
          </p>
          <fg-input
            v-model="model.account"
            v-validate="'required'"
            name="account"
            :error="getError('account')"
            class="no-border form-control-lg"
            placeholder="Account"
            addon-left-icon="now-ui-icons users_circle-08"
          ></fg-input>

          <fg-input
            v-model="model.email"
            v-validate="'required|email'"
            name="username"
            :error="getError('username')"
            class="no-border form-control-lg"
            placeholder="Email"
            addon-left-icon="now-ui-icons ui-1_email-85"
          ></fg-input>

          <fg-input
            v-model="model.password"
            v-validate="'required|min:5'"
            type="password"
            name="password"
            :error="getError('password')"
            class="no-border form-control-lg"
            placeholder="Password"
            addon-left-icon="now-ui-icons ui-1_lock-circle-open"
          ></fg-input>
        </div>

        <div slot="footer">
          <div class="d-block text-center mb-2">版本：v{{version}}</div>
          <n-button native-type="submit" type="success" round block size="lg">登入</n-button>
          <!-- <div class="pull-left">
            <h6>
              <router-link class="link footer-link" to="/register">
                Create Account
              </router-link>
            </h6>
          </div>

          <div class="pull-right">
            <h6><a href="#pablo" class="link footer-link">Need Help?</a></h6>
          </div>-->
        </div>
      </card>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "login",
  data() {
    return {
      signinError: false,
      model: {
        account: "",
        email: "",
        password: ""
      }
    };
  },
  computed: {
    version() {
      return process.env.PACKAGE_VERSION;
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async login() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        // TIP use this.model to send it to api and perform login call
        // 因為 action 包裝了 Promise 所以可以使用 then 和 catch 來接收非同步回傳狀態
        this.$store
          .dispatch("login", {
            type: "si",
            account: this.model.account,
            username: this.model.email,
            password: this.model.password
          })
          .then(() => {
            // 接收 resolve
            // console.log('3. get Promise resolve');
            setTimeout(() => {
              // 使用 $router.push 轉跳到 hello Page
              this.$router.push("/retail/summary/stat");
            }, 1000);
          })
          .catch(e => {
            // 接收 reject
            this.signinError = true;
            console.log("error get Promise reject!" + e.stack);
          });
      }
    }
  },
  watch: {
    'model.email': function(val){
        if(typeof val == 'string') this.model.email = val.trim();
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
